import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-406bc52c")

_pushScopeId("data-v-406bc52c")
const _hoisted_1 = { class: "text-gray-333 enter-desired-shift-container" }
const _hoisted_2 = { class: "flex mt-16 mb-10 items-center" }
const _hoisted_3 = { class: "flex mr-32" }
const _hoisted_4 = { class: "mr-10 text-right font-size-18" }
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "font-size-18" }
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = { class: "mr-6" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "mr-6" }, "～", -1)
const _hoisted_12 = { class: "mb-6" }
const _hoisted_13 = { class: "w-50" }
const _hoisted_14 = { class: "flex justify-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "mt-1 p-2" }, "～", -1)
const _hoisted_16 = { class: "relative h-full -m-1" }
const _hoisted_17 = { class: "h-full items-center justify-center flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Select = _resolveComponent("Select")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('departmentToBeShifted')), 1),
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('applicationSubmit')), 1),
          _createVNode("div", null, _toDisplayString(_ctx.t('submissionDeadline')), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.requestMyShift.unit_name), 1),
          _createVNode("div", _hoisted_9, [
            _createVNode("span", _hoisted_10, _toDisplayString(_ctx.requestMyShift.register_start_date), 1),
            _hoisted_11,
            _createVNode("span", null, _toDisplayString(_ctx.requestMyShift.register_end_date), 1)
          ]),
          _createVNode("div", null, _toDisplayString(_ctx.requestMyShift.deadline), 1)
        ])
      ]),
      _createVNode("div", null, [
        (_ctx.isBtnHandOver)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "btn-light-blue radius-40px w-60 h-12 font-size-18",
              onClick: _ctx.onClickBtnHandOver
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('handOver')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "btn-red-ff radius-40px w-60 h-12 font-size-18",
              onClick: _ctx.onClickBtnWithdrawSubmission
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('withdrawSubmission')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
      ])
    ]),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_DatePicker, {
          width: "120",
          format: "YYYY/MM",
          type: "month",
          "is-icon-chevron-right": "",
          "is-icon-chevron-left": "",
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_Table, {
        class: "text-center",
        headers: _ctx.submitDesiredHeaders,
        data: _ctx.requestMyShiftPostData.dates
      }, {
        date: _withId(({ item }) => [
          _createVNode("div", {
            style: { color: _ctx.getColorDate(item.target_date) }
          }, _toDisplayString(_ctx.displayDate(item.target_date)), 5)
        ]),
        desired_work_pattern: _withId(({ index }) => [
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_Select, {
              "custom-value": _ctx.employeeExpertTypeText(index),
              class: "text-white",
              background: _ctx.getBackgroundOptionEmployeeExpectType(index),
              modelValue: _ctx.requestMyShiftPostData.dates[index].employe_expect_type,
              "onUpdate:modelValue": ($event: any) => (_ctx.requestMyShiftPostData.dates[index].employe_expect_type = $event),
              "options-select": _ctx.shiftPatternOptions,
              "item-value": "value",
              "item-text": "text",
              onHoverItem: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openShiftPatternList($event))),
              onHoverLeaveItem: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeShiftPatternList($event))),
              onChange: ($event: any) => (_ctx.changeEmployeeExpertType(index))
            }, {
              default: _withId(({ item }) => [
                (
                    item.value === _ctx.EMPLOYEE_EXPERT_TYPE.SELECT_FROM_WORK_PATTERN
                  )
                  ? _withDirectives((_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "fixed shift-pattern-dropdown",
                      style: {
                    top: _ctx.stylePositionShiftPatternList.top,
                    left: _ctx.stylePositionShiftPatternList.left,
                  }
                    }, [
                      _createVNode("ul", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.shiftPatternData, (item) => {
                          return (_openBlock(), _createBlock("li", {
                            class: ["shift-pattern-dropdown--item", 
                        _ctx.requestMyShiftPostData.dates[index]
                          .expected_shift_pattern_id === item.shift_pattern_id
                          ? 'active'
                          : ''
                      ],
                            key: item.shift_pattern_id,
                            onClick: ($event: any) => (_ctx.choseShiftPattern(item, index))
                          }, _toDisplayString(item.shift_pattern_name), 11, ["onClick"]))
                        }), 128))
                      ])
                    ], 4)), [
                      [_vShow, _ctx.isShowShiftPatternList]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["custom-value", "background", "modelValue", "onUpdate:modelValue", "options-select", "onChange"])
          ])
        ]),
        target_time: _withId(({ index }) => [
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_InputTime, {
              width: "96px",
              modelValue: 
                _ctx.requestMyShiftPostData.dates[index]
                  .employee_expect_work_start_time
              ,
              "onUpdate:modelValue": ($event: any) => (
                _ctx.requestMyShiftPostData.dates[index]
                  .employee_expect_work_start_time
               = $event),
              disabled: _ctx.disableInputTime(index),
              validated: _ctx.validated,
              required: 
                _ctx.requestMyShiftPostData.dates[index].employe_expect_type ===
                _ctx.EMPLOYEE_EXPERT_TYPE.ADD_MANUALLY
              ,
              errors: 
                _ctx.errors[`dates.${index}.employee_expect_work_start_time`]
              ,
              "onUpdate:errors": ($event: any) => (
                _ctx.errors[`dates.${index}.employee_expect_work_start_time`]
               = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "validated", "required", "errors", "onUpdate:errors"]),
            _hoisted_15,
            _createVNode(_component_InputTime, {
              width: "96px",
              modelValue: 
                _ctx.requestMyShiftPostData.dates[index]
                  .employee_expect_work_end_time
              ,
              "onUpdate:modelValue": ($event: any) => (
                _ctx.requestMyShiftPostData.dates[index]
                  .employee_expect_work_end_time
               = $event),
              disabled: _ctx.disableInputTime(index),
              validated: _ctx.validated,
              required: 
                _ctx.requestMyShiftPostData.dates[index].employe_expect_type ===
                _ctx.EMPLOYEE_EXPERT_TYPE.ADD_MANUALLY
              ,
              errors: 
                _ctx.errors[`dates.${index}.employee_expect_work_end_time`]
              ,
              "onUpdate:errors": ($event: any) => (
                _ctx.errors[`dates.${index}.employee_expect_work_end_time`]
               = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "validated", "required", "errors", "onUpdate:errors"])
          ])
        ]),
        time_min: _withId(({ index }) => [
          _createVNode("div", _hoisted_16, [
            (_ctx.isShowTimeLineRequest(index))
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "time-line time-line-blue",
                  style: 
                _ctx.styleTimeLine(
                  _ctx.requestMyShiftPostData.dates[index]
                    ?.employee_expect_work_start_time,
                  _ctx.requestMyShiftPostData.dates[index]
                    ?.employee_expect_work_end_time
                )
              
                }, null, 4))
              : (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: "time-line time-line-grey",
                  style: 
                _ctx.styleTimeLine(
                  _ctx.requestMyShift.submit_desired_shifts[index]
                    ?.shift_plan_employee_date?.employee_expect_work_start_time,
                  _ctx.requestMyShift.submit_desired_shifts[index]
                    ?.shift_plan_employee_date?.employee_expect_work_end_time
                )
              
                }, null, 4)),
            _createVNode("div", {
              class: "time-line time-line-red",
              style: 
                _ctx.styleTimeLine(
                  _ctx.requestMyShift.submit_desired_shifts[index]
                    ?.shift_plan_employee_date.manager_confirm_work_start_time,
                  _ctx.requestMyShift.submit_desired_shifts[index]
                    ?.shift_plan_employee_date.manager_confirm_work_end_time
                )
              
            }, [
              _createVNode("div", _hoisted_17, [
                _createVNode("span", null, _toDisplayString(_ctx.displayManagerConfirmWorkTime(
                    _ctx.requestMyShift.submit_desired_shifts[index]
                  )), 1)
              ])
            ], 4)
          ])
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ])
  ]))
})